import React from "react";
import { Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useAlertsOverview } from "../../Hooks/useAlertsOverview";

/**
 * Presentación de cada tipo de alerta.
 *
 * Las claves son los ALERT_TYPES de insight-ms y llegan tal cual en
 * summary.by_type. El orden del array es el orden en que se pintan; el conteo
 * lo pone el backend, aquí sólo se le da forma.
 *
 * La tarjeta muestra CONTEOS por detector, no alertas sueltas: `useAlertsOverview`
 * es la consulta liviana del tablero a propósito, y traer la lista paginada
 * aquí duplicaría la consulta cara de la pantalla de alertas.
 */
const ALERT_CARDS = [
    {
        type: "FAILED_PURCHASE_ATTEMPTS",
        color: "#DC2626",
        title: "Intentos de compra fallidos",
        text: "Usuarios con más de 3 compras fallidas"
    },
    {
        type: "NETWORK_NO_GROWTH",
        color: "#C2740A",
        title: "Redes sin crecimiento",
        text: "Sin afiliaciones en el período"
    },
    {
        type: "SALES_DROP",
        color: "#DC2626",
        title: "Caída abrupta en ventas",
        text: "Contra el período anterior equivalente"
    },
    {
        type: "NETWORK_DEPENDENCY",
        color: "#C2740A",
        title: "Dependencia de red inferior",
        text: "Una línea concentra el volumen"
    }
];

const CriticalAlertsCard = () => {

    const navigate = useNavigate();
    const { countsByType, summaryLoading, error } = useAlertsOverview();

    const total = ALERT_CARDS.reduce(
        (sum, item) => sum + (countsByType?.[item.type] ?? 0),
        0
    );

    return (

        <div className="ui-card">

            <div className="ui-card__head" style={{ marginBottom: 16 }}>
                <h2 className="ui-card__title">
                    <i className="ri-alarm-warning-line" style={{ color: "#DC2626", fontSize: 18 }} />
                    Alertas críticas
                    {total > 0 && <span className="ui-card__count">{total}</span>}
                </h2>

                <button
                    type="button"
                    className="ui-link"
                    onClick={() => navigate("/critical-alerts")}
                >
                    Ver todas
                </button>
            </div>

            {summaryLoading && (
                <div className="text-center py-4">
                    <Spinner size="sm" />
                </div>
            )}

            {!summaryLoading && error && (
                <div className="ui-note ui-note--danger">
                    No se pudieron cargar las alertas.
                </div>
            )}

            {!summaryLoading && !error && (
                <div className="ui-feed">
                    {ALERT_CARDS.map((item) => {
                        // Un tipo sin alertas abiertas no viene en el mapa; se
                        // pinta en 0 y no se esconde, para que la tarjeta
                        // siempre muestre las cuatro filas.
                        const count = countsByType?.[item.type] ?? 0;

                        return (
                            <button
                                key={item.type}
                                type="button"
                                className="ui-feed__row"
                                onClick={() => navigate("/critical-alerts")}
                            >
                                <span
                                    className="ui-feed__dot"
                                    style={{ background: item.color }}
                                />

                                <span className="ui-feed__body">
                                    <span className="ui-feed__title d-block">{item.title}</span>
                                    <span className="ui-feed__detail d-block">{item.text}</span>
                                </span>

                                <span
                                    style={{
                                        color: item.color,
                                        fontWeight: 800,
                                        fontSize: 18,
                                        letterSpacing: "-0.02em"
                                    }}
                                >
                                    {count.toLocaleString("es-CO")}
                                </span>

                                <i className="ri-arrow-right-s-line ui-feed__chev" />
                            </button>
                        );
                    })}
                </div>
            )}

        </div>

    );

};

export default CriticalAlertsCard;
